import { createContext } from "react";
import { SlackSocketMessage } from "../models/slackSocketModel";

export const SlackNotificationContext = createContext<SlackSocketMessage[]>([]);
